// data/servicesData.js
import webDevIcon from "../assets/images/code-icon.png";
import mobileAppIcon from "../assets/images/app-dev-icon.png";
import graphicsDesignIcon from "../assets/images/design-icon.png";
import photographyIcon from "../assets/images/photography-icon.png";
import digitalMarketingIcon from "../assets/images/digitalmarketing-icon.png";
import printIcon from "../assets/images/print-on-demand-line-icon-illust.png";

export const serviceCategories = [
  {
    id: 1,
    title: "Web Development",
    icon: webDevIcon,
    description:
      "Custom, responsive websites built with cutting-edge technology to drive your business forward.",
    subcategories: [
      {
        title: "E-commerce Solutions",
        description:
          "Powerful online stores with secure payment gateways and inventory management.",
        features: [
          "Shopping Cart",
          "Payment Integration",
          "Product Management",
          "Order Tracking",
          "Inventory Control",
        ],
      },
      {
        title: "Corporate Websites",
        description:
          "Professional websites that showcase your brand and engage your audience.",
        features: [
          "CMS Integration",
          "SEO Optimized",
          "Contact Forms",
          "Analytics",
          "Blog Setup",
        ],
      },
      {
        title: "Custom Web Apps",
        description:
          "Tailored web applications built to solve your specific business challenges.",
        features: [
          "Database Design",
          "API Integration",
          "Real-time Features",
          "Scalable Architecture",
          "Cloud Hosting",
        ],
      },
      {
        title: "Landing Pages",
        description:
          "High-converting landing pages designed for marketing campaigns.",
        features: [
          "A/B Testing",
          "Lead Capture",
          "Mobile Optimized",
          "Fast Loading",
          "CTA Optimization",
        ],
      },
      {
        title: "Web Portals",
        description:
          "Feature-rich portals for customers, employees, or partners.",
        features: [
          "User Authentication",
          "Role-based Access",
          "Dashboard",
          "Notifications",
          "File Management",
        ],
      },
    ],
  },
  {
    id: 2,
    title: "Mobile App Development",
    icon: mobileAppIcon,
    description:
      "Native and cross-platform mobile applications that deliver exceptional user experiences.",
    subcategories: [
      {
        title: "iOS Apps",
        description:
          "Beautiful, intuitive iOS applications optimized for Apple devices.",
        features: [
          "Swift/SwiftUI",
          "App Store Ready",
          "Apple Pay",
          "Push Notifications",
          "Face ID/Touch ID",
        ],
      },
      {
        title: "Android Apps",
        description:
          "Feature-rich Android applications for the Google Play Store.",
        features: [
          "Kotlin/Java",
          "Material Design",
          "Google Services",
          "Offline Mode",
          "Firebase Integration",
        ],
      },
      {
        title: "Cross-Platform Apps",
        description:
          "Build once, deploy everywhere with React Native or Flutter.",
        features: [
          "Code Reusability",
          "Native Performance",
          "Single Codebase",
          "Faster Development",
          "Cost Effective",
        ],
      },
      {
        title: "App Maintenance",
        description:
          "Ongoing support and updates to keep your app running smoothly.",
        features: [
          "Bug Fixes",
          "OS Updates",
          "Performance Monitoring",
          "24/7 Support",
          "Security Patches",
        ],
      },
    ],
  },
  {
    id: 3,
    title: "Graphics Design",
    icon: graphicsDesignIcon,
    description:
      "Creative visual solutions that make your brand stand out from the crowd.",
    subcategories: [
      {
        title: "Brand Identity",
        description:
          "Complete brand packages including logos, colors, and typography.",
        features: [
          "Logo Design",
          "Brand Guidelines",
          "Color Palette",
          "Typography",
          "Business Cards",
        ],
      },
      {
        title: "UI/UX Design",
        description: "User-centered design that enhances digital experiences.",
        features: [
          "Wireframing",
          "Prototyping",
          "User Testing",
          "Interactive Design",
          "User Flows",
        ],
      },
      {
        title: "Print Design",
        description: "High-quality print materials for your marketing needs.",
        features: [
          "Brochures",
          "Business Cards",
          "Flyers",
          "Posters",
          "Banners",
        ],
      },
      {
        title: "Social Media Graphics",
        description: "Engaging visuals optimized for all social platforms.",
        features: [
          "Post Templates",
          "Story Designs",
          "Cover Images",
          "Ad Creatives",
          "Animations",
        ],
      },
    ],
  },
  {
    id: 4,
    title: "Photography",
    icon: photographyIcon,
    description:
      "Professional photography services that capture your brand's essence.",
    subcategories: [
      {
        title: "Product Photography",
        description: "Stunning product images that drive sales and engagement.",
        features: [
          "Studio Setup",
          "360° Views",
          "Post-processing",
          "White Background",
          "Lifestyle Shots",
        ],
      },
      {
        title: "Corporate Events",
        description:
          "Comprehensive coverage of your business events and conferences.",
        features: [
          "Event Coverage",
          "Candid Shots",
          "Group Photos",
          "Quick Delivery",
          "Photo Editing",
        ],
      },
      {
        title: "Brand Photography",
        description: "Custom photos that tell your brand's unique story.",
        features: [
          "Concept Planning",
          "Location Shoots",
          "Model Direction",
          "Editing",
          "Retouching",
        ],
      },
      {
        title: "Real Estate Photography",
        description:
          "Professional photos that showcase properties beautifully.",
        features: [
          "Interior Shots",
          "Exterior Shots",
          "Virtual Tours",
          "Drone Photography",
          "Twilight Shots",
        ],
      },
    ],
  },
  {
    id: 5,
    title: "Digital Marketing",
    icon: digitalMarketingIcon,
    description:
      "Data-driven marketing strategies that deliver measurable results.",
    subcategories: [
      {
        title: "SEO Services",
        description:
          "Improve your visibility and rank higher in search results.",
        features: [
          "Keyword Research",
          "On-page SEO",
          "Link Building",
          "Analytics",
          "Local SEO",
        ],
      },
      {
        title: "Social Media Marketing",
        description: "Build and engage your audience across social platforms.",
        features: [
          "Content Creation",
          "Community Management",
          "Paid Ads",
          "Analytics",
          "Influencer Outreach",
        ],
      },
      {
        title: "PPC Advertising",
        description: "Targeted campaigns that drive immediate results.",
        features: [
          "Google Ads",
          "Facebook Ads",
          "Remarketing",
          "Conversion Tracking",
          "A/B Testing",
        ],
      },
      {
        title: "Email Marketing",
        description: "Nurture leads and retain customers with email campaigns.",
        features: [
          "Newsletter Design",
          "Automation",
          "Segmentation",
          "A/B Testing",
          "Analytics",
        ],
      },
      {
        title: "Content Marketing",
        description:
          "Valuable content that attracts and retains your audience.",
        features: [
          "Blog Posts",
          "White Papers",
          "Case Studies",
          "Video Scripts",
          "Infographics",
        ],
      },
    ],
  },
  {
    id: 6,
    title: "Print on Demand",
    icon: printIcon,
    description:
      "High-quality custom printing services for all your promotional and personal needs. We bring your designs to life on various products.",
    subcategories: [
      {
        title: "T-Shirt Printing",
        description:
          "Custom t-shirt printing using high-quality materials and advanced printing techniques. Perfect for events, promotions, or personal use.",
        features: [
          "DTG Printing",
          "Screen Printing",
          "Heat Transfer",
          "Sublimation",
          "Bulk Orders",
          "Custom Designs",
        ],
      },
      {
        title: "Mug Printing",
        description:
          "Personalized mugs for gifts, corporate events, or promotional merchandise. Durable prints that last.",
        features: [
          "Sublimation Printing",
          "Full Color Prints",
          "Heat Resistant",
          "Dishwasher Safe",
          "Bulk Discounts",
          "Custom Messages",
        ],
      },
      {
        title: "Panaflex Printing",
        description:
          "Large format panaflex printing for outdoor advertising, billboards, and signage. Weather-resistant and vibrant.",
        features: [
          "Weather Resistant",
          "UV Protected",
          "High Resolution",
          "Various Sizes",
          "Night Visibility",
          "Long Lasting",
        ],
      },
      {
        title: "Brochures",
        description:
          "Professional brochure printing for marketing, events, and business promotions. Multiple folds and finishes available.",
        features: [
          "Glossy/Matte Finish",
          "Multiple Folds",
          "High Quality Paper",
          "Full Color",
          "Fast Turnaround",
          "Bulk Printing",
        ],
      },
      {
        title: "Flyers",
        description:
          "Eye-catching flyer printing for promotions, events, and advertising campaigns. Various sizes and paper options.",
        features: [
          "A5/A6 Sizes",
          "Glossy/Matte Paper",
          "Full Color",
          "Double Sided",
          "Bulk Discounts",
          "Quick Delivery",
        ],
      },
      {
        title: "Business Cards",
        description:
          "Premium business card printing to make a lasting impression. Various finishes and paper stocks available.",
        features: [
          "Premium Card Stock",
          "Spot UV Available",
          "Foil Stamping",
          "Embossing",
          "Corner Rounding",
          "Matt/Gloss Lamination",
        ],
      },
      {
        title: "Posters",
        description:
          "High-quality poster printing for events, promotions, and decor. Various sizes and paper options.",
        features: [
          "Multiple Sizes",
          "High Resolution",
          "Glossy/Matte",
          "Weather Resistant",
          "Indoor/Outdoor",
          "Bulk Orders",
        ],
      },
      {
        title: "Banners",
        description:
          "Durable banner printing for indoor and outdoor use. Perfect for events, promotions, and signage.",
        features: [
          "Vinyl Material",
          "Weather Resistant",
          "Grommets Included",
          "High Resolution",
          "Custom Sizes",
          "Fast Production",
        ],
      },
      {
        title: "Stickers & Labels",
        description:
          "Custom stickers and labels for branding, packaging, or promotions. Various shapes, sizes, and materials.",
        features: [
          "Vinyl Stickers",
          "Paper Labels",
          "Custom Shapes",
          "Water Resistant",
          "Kiss Cut",
          "Bulk Orders",
        ],
      },
      {
        title: "Hoodies & Sweatshirts",
        description:
          "Custom printed hoodies and sweatshirts for comfort and style. Perfect for merchandise or gifts.",
        features: [
          "Various Colors",
          "Sizes S-XXL",
          "Embroidery Available",
          "Screen Printing",
          "High Quality Fabric",
          "Bulk Discounts",
        ],
      },
    ],
  },
];

// Optional: Export hero stats separately for easy editing
export const heroStats = [
  {
    number: "50+",
    label: "Projects Completed",
  },
  {
    number: "24/7",
    label: "Client Support",
  },
  {
    number: "100%",
    label: "Satisfaction",
  },
];

// Optional: Export hero content separately
export const heroContent = {
  title: "Our Services",
  subtitle: "Comprehensive digital solutions tailored to your business needs",
};
